<script setup lang='ts'>

</script>
<template>
General Assembly view page {{$route.params.id}}
</template>
